import { useLayoutEffect } from 'react';

export default function usePageBackground(className) {
  useLayoutEffect(() => {
    const main = document.querySelector('main');
    const body = document.body;
    if (main && className) main.classList.add(className);
    if (body && className) body.classList.add(className);
    return () => {
      if (main && className) main.classList.remove(className);
      if (body && className) body.classList.remove(className);
    };
  }, [className]);
}

